module.exports = __webpack_public_path__ + "static/img/fair_isle_knitting_circle_logo.29d7769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fair_isle_knitting_circle_logo.png
// module id = 67
// module chunks = 1